<template>
  <div class="user-manage">
    <el-row class="white">
      <el-col :offset="1" :span="23">
        <query-form :form="form" v-model="timeStrategy" @handleQuery="handleQuery" />
      </el-col>
    </el-row>
    <base-table
    :columns="columns"
    :data="timeStrategyList"
    :pager="pager"
    :pageShow="pageShow"
    @handleAction="handleAction"
    @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:action>
      <el-button type="primary" @click="handleCreate">新增</el-button>
      </template>
    </base-table>
    <el-dialog :title="dialogTitle" v-model="showModal" @close="handleClose">
      <el-form ref="dialogForm" :model="timeStrategyForm" label-width="110px" :rules="rules">
        <el-form-item label="计费规则名称" prop="timeStrategyName">
          <el-input v-model="timeStrategyForm.timeStrategyName" placeholder="请输入计费规则名称"/>
        </el-form-item>
        <el-form-item label="计费类型" prop="type">
          <el-select v-model="timeStrategyForm.type">
            <el-option value="time" label="小时计价"></el-option>
            <el-option value="number" label="单次计价"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="time-statement" label="基础时间" prop="baseTime">
          <el-input v-model.number="timeStrategyForm.baseTime" placeholder="请输入基础时间"/>
          <el-tag color="rgb(255, 255, 255)">分钟</el-tag>
        </el-form-item>
        <el-form-item class="time-statement" label="基础限免时间" prop="maxFreeTime">
          <el-input v-model.number="timeStrategyForm.maxFreeTime" placeholder="请输入基础限免时间"/>
          <el-tag color="rgb(255, 255, 255)">分钟</el-tag>
        </el-form-item>
        <el-form-item class="time-statement" label="阶梯时间" prop="stepTime">
          <el-input v-model.number="timeStrategyForm.stepTime" placeholder="请输入阶梯时间"/>
          <el-tag color="rgb(255, 255, 255)">分钟</el-tag>
        </el-form-item>
        <el-form-item class="time-statement" label="阶梯限免时间" prop="maxStepTime">
          <el-input v-model.number="timeStrategyForm.maxStepTime" placeholder="请输入阶梯限免时间"/>
          <el-tag color="rgb(255, 255, 255)">分钟</el-tag>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" :rows="2" v-model="timeStrategyForm.description" placeholder="请输入描述"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref, toRaw } from 'vue'
import utils from './../../utils/utils'
export default {
  name: 'user',
  setup () {
    // 获取Composition API 上下文对象
    const { proxy } = getCurrentInstance()
    let queryValue = {}
    const form = [
      {
        type: 'input',
        label: '计费规则名称',
        model: 'timeStrategyName',
        placeholder: '请输入计费规则名称'
      },
      {
        type: 'select',
        label: '计费类型',
        model: 'type',
        placeholder: '请选择计费类型',
        options: [
          {
            label: '全部',
            value: 'all'
          },
          {
            label: '小时计价',
            value: 'time'
          },
          {
            label: '单次计价',
            value: 'number'
          }
        ]
      }
      // {
      //   type: 'date',
      //   label: '添加时间',
      //   model: 'createTime',
      //   placeholder: '请输入添加时间'
      // }
    ]
    // 初始化表单对象
    const timeStrategy = ref({
      type: ''
    })
    // 初始化列表对象
    const timeStrategyList = ref([])
    // 初始化计费规则对象
    const TimeStrategyInfoList = ref([])
    // 初始化分页对象
    const pager = reactive({
      pageNum: 1,
      pageSize: 10
    })
    // 是否展示分页
    const pageShow = ref(true)
    // 弹框显示对象
    const showModal = ref(false)
    // 新增Form对象
    const timeStrategyForm = reactive({})
    // 弹框的标题
    const dialogTitle = ref('')
    // 弹框的操作
    const action = ref('add')
    // 定义表单校验规则
    const rules = reactive({
      timeStrategyName: [
        {
          required: true,
          message: '请输入计费规则名称',
          trigger: 'blur'
        }
      ],
      type: [
        {
          required: true,
          message: '请选择计费类型',
          trigger: 'blur'
        }
      ],
      baseTime: [
        {
          required: true,
          message: '请输入基础时间',
          trigger: 'blur'
        },
        {
          type: 'number',
          message: '基础时间必须是数字',
          trigger: 'blur'
        }
      ],
      maxFreeTime: [
        {
          required: true,
          message: '请输入基础限免时间',
          trigger: 'blur'
        },
        {
          type: 'number',
          message: '基础限免时间必须是数字',
          trigger: 'blur'
        }
      ],
      stepTime: [
        {
          required: true,
          message: '请输入阶梯时间',
          trigger: 'blur'
        },
        {
          type: 'number',
          message: '阶梯时间必须是数字',
          trigger: 'blur'
        }
      ],
      maxStepTime: [
        {
          required: true,
          message: '请输入阶梯限免时间',
          trigger: 'blur'
        },
        {
          type: 'number',
          message: '阶梯限免时间必须是数字',
          trigger: 'blur'
        }
      ],
    })
    // 定义动态表格-格式
    const columns = reactive([
      // {
      //   type: 'selection'
      // },
      {
        label: '计费规则名称',
        prop: 'timeStrategyName'
      },
      {
        label: '计费类型',
        prop: 'type',
        formatter (row, column, value) {
          if (value === 'time') {
            return '小时计价'
          } else if (value === 'number') {
            return '单次计价'
          }
        }
      },
      {
        label: '基础时间(分钟)',
        prop: 'baseTime'
      },
      {
        label: '基础限免时间(分钟)',
        prop: 'maxFreeTime'
      },
      {
        label: '阶梯时间(分钟)',
        prop: 'stepTime'
      },
      {
        label: '阶梯限免时间(分钟)',
        prop: 'maxStepTime'
      },
      {
        type: 'action',
        label: '操作',
        list: [
          {
            type: 'primary',
            text: '修改',
            visible: true
          },
          {
            type: 'danger',
            text: '删除',
            visible: true
          }
        ]
      }
    ])
    // 初始化接口调用
    onMounted(() => {
      gettimeStrategyInfoList()
    })
    // 获取船种列表
    const gettimeStrategyInfoList = async (values) => {
      const params = utils.pageService(pager, values);

      // const res = await proxy.$api.getWharfList(params)
      // console.log(res)
      try {
        const res = await proxy.$api.getTimeStrategyInfoList(params)
        timeStrategyList.value = res.data
        pager.total = res.totalNum
      } catch (error) {
        console.log(error)
      }
    }
    // 查询事件， 获取列表
    const handleQuery = (values) => {
      const newValues = utils.checkParmas(values)
      pager.pageNum = 1
      pageShow.value = false
      queryValue = newValues
      gettimeStrategyInfoList(newValues)
      proxy.$nextTick(() => {
        pageShow.value = true
      })
    }
    // 重置查询表单
    const handleReset = (form) => {
      proxy.$refs[form].resetFields()
      // gettimeStrategyInfoList()
    }
    // 分页事件处理
    const handleCurrentChange = (current) => {
      pager.pageNum = current
      gettimeStrategyInfoList(queryValue)
    }
    // 单个删除
    const handleDel = (row) => {
      proxy.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const data = await proxy.$api.delTimeStrategyInfo({ _id: row._id });
        if(data){
          proxy.$message({
            type: 'success',
            message: '删除成功!'
          })
          gettimeStrategyInfoList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
    // 新增表单
    const handleCreate = () => {
      action.value = 'add'
      dialogTitle.value = '新增'
      showModal.value = true
    }
    // 编辑表单
    const handleEdit = (row) => {
      action.value = 'edit'
      dialogTitle.value = '修改'
      showModal.value = true
      proxy.$nextTick(() => {
        timeStrategyForm._id = row._id
        timeStrategyForm.timeStrategyName = row.timeStrategyName
        timeStrategyForm.type = row.type
        timeStrategyForm.baseTime = row.baseTime
        timeStrategyForm.maxFreeTime = row.maxFreeTime
        timeStrategyForm.stepTime = row.stepTime
        timeStrategyForm.maxStepTime = row.maxStepTime
        timeStrategyForm.description = row.description
      })
    };
    // 弹框关闭
    const handleClose = () => {
      showModal.value = false
      handleReset('dialogForm')
    }
    // 处理按钮
    const handleAction = (values) => {
      if (values.index === 0) {
        handleEdit(values.row)
      } else if (values.index === 1) {
        handleDel(values.row)
      }
    };

    // 弹框提交
    const handleSubmit = () => {
      proxy.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          const userAction = action.value
          // console.log(userAction)
          if (userAction === 'add') {
            const params = toRaw(timeStrategyForm)
            if (params._id) {
              delete params._id
            }
            params.baseTime = parseInt(params.baseTime)
            params.maxFreeTime = parseInt(params.maxFreeTime)
            params.stepTime = parseInt(params.stepTime)
            params.maxStepTime = parseInt(params.maxStepTime)
            const res = await proxy.$api.addTimeStrategyInfo(params)
            if (res) {
              showModal.value = false
              proxy.$message.success('船种创建成功')
              handleReset('dialogForm')
              gettimeStrategyInfoList()
            }
          } else {
            const params = toRaw(timeStrategyForm)
            params.baseTime = parseInt(params.baseTime)
            params.maxFreeTime = parseInt(params.maxFreeTime)
            params.stepTime = parseInt(params.stepTime)
            params.maxStepTime = parseInt(params.maxStepTime)
            const res = await proxy.$api.editTimeStrategyInfo(params)
            if (res) {
              showModal.value = false
              proxy.$message.success('规则编辑成功')
              handleReset('dialogForm')
              gettimeStrategyInfoList()
            }
          }
        }
      })
    }
    return {
      form,
      timeStrategy,
      gettimeStrategyInfoList,
      TimeStrategyInfoList,
      timeStrategyList,
      columns,
      pager,
      handleQuery,
      handleReset,
      handleCurrentChange,
      handleDel,
      handleCreate,
      showModal,
      timeStrategyForm,
      rules,
      handleClose,
      handleSubmit,
      action,
      handleAction,
      handleEdit,
      dialogTitle,
      pageShow
    }
  }
}
</script>

<style lang="less">

</style>
